<template>
  <div class="basic_wrap choose-page">
    <div class="red_top_bg page-top">
      <button
        type="button"
        class="language"
        @click="$router.push('/language')"
      >
        <img
          :src="require('../images/language/' + lang + '.png')"
          alt=""
        >
      </button>
      <div class="big_tit">
        {{ $t('sky.xuan') }}
      </div>
    </div>

    <van-swipe
      v-if="banner"
      class="banner-swipe"
      :autoplay="3000"
      lazy-render
    >
      <van-swipe-item
        v-for="(item, index) in banner"
        :key="index"
      >
        <img
          :src="item[lang]"
          alt=""
        >
      </van-swipe-item>
    </van-swipe>

    <div class="head-tabs">
      <span
        class="tab-item active"
        @click="cur = 0; resetGirls();"
      >{{ $t('feng.ads') }}</span>
    </div>

    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        :offset="100"
        :loading-text="$t('pro2.loading')"
        @load="loadGirls"
      >
        <div
          v-if="girls.length"
          class="pblBox"
        >
          <article
            v-for="(item, index) in girls"
            :key="item.id || index"
            class="releaseItem"
            @click="$router.push('/vprofile/' + item.id)"
          >
            <div class="imgBox">
              <img
                :src="item.pic"
                alt=""
              >
              <span class="corner-ribbon">
                <i>{{ $t('sky.gaoduan') }}</i>
              </span>
              <div class="infoBox">
                <van-icon
                  name="location"
                  class="location-icon"
                />
                <div class="wantyuebtn">
                  {{ $t('sky.yue') }}
                </div>
              </div>
            </div>
            <div class="tagBox">
              <span
                v-for="tag in getGirlTags(item)"
                :key="tag"
                class="tag"
              >
                {{ tag }}
              </span>
            </div>
            <div class="di">
              <div class="name-row">
                <span class="dot" />
                <span>{{ item.name }}</span>
              </div>
              <div class="like-row">
                <van-icon name="like" />
                <span>{{ item.zan }}</span>
              </div>
            </div>
          </article>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
	Swipe,
	SwipeItem,
	Empty,
	List,
	Icon,
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(List).use(Icon);

export default {
	name: "Choose",
	components: {
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: null,
			loading: false,
			page: 1,
			girls: [],
			banner: null,
			cur: 0,
			area: null,
			arealist: null,
			islogin: false,
			locationsel: false,
			type: 0,
			finished: false,
			empty: false,
			requestLock: false,
		};
	},
	created() {
		this.$parent.footer("girl", true);
	},
	mounted() {
		this.islogin = localStorage.getItem("token") != null;
		if (!this.islogin) {
			this.$router.push("/login");
		}
		this.getBanner();
	},
	methods: {
		getBanner() {
			Fetch("/index/int").then(r => {
				this.banner = r.data.banner;
			});
		},
		resetGirls() {
			this.page = 1;
			this.girls = [];
			this.finished = false;
			this.empty = false;
			this.requestLock = false;
			this.loading = true;
			this.loadGirls();
		},
		loadGirls() {
			if (this.requestLock || this.finished) {
				this.loading = false;
				return;
			}
			this.requestLock = true;
			Fetch("/index/girls", {
				page: this.page,
			}).then(r => {
				var rows = r.data && r.data.list ? r.data.list : [];

				for (var i = 0; i < rows.length; i++) {
					rows[i].keys = rows[i].keystr ? rows[i].keystr.split("|") : [];
				}
				if (rows.length > 0) {
					this.girls = this.girls.concat(rows);
					this.page++;
				}
				this.empty = this.girls.length === 0;
				this.finished = !(r.data && r.data.has_more);
				this.loading = false;
				this.requestLock = false;
			}).catch(() => {
				this.loading = false;
				this.requestLock = false;
				this.finished = true;
			});
		},
		getGirlTags(item) {
			return item && item.keys ? item.keys.slice(0, 4).filter(Boolean) : [];
		},
	},
};
</script>

<style lang="less" scoped>
.choose-page {
	min-height: 100vh;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: #191818;
	color: #f5f1ec;
	overflow: hidden;
}

.page-top {
	height: 44px;
	flex: 0 0 44px;
	background: #191818;
	color: #f5f1ec;
	border-bottom: 1px solid rgba(112, 90, 68, 0.45);
	box-sizing: border-box;

	.big_tit {
		color: #f5f1ec;
	}
}

.language {
	position: absolute;
	top: 6px;
	left: 15px;
	width: 32px;
	height: 32px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(104, 82, 58, 0.52);
}

.language img {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	object-fit: cover;
}

.banner-swipe {
	flex: 0 0 auto;
	margin: 14px 16px 0;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(128, 101, 74, 0.88);
	background: #292929;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
}

.banner-swipe img {
	display: block;
	width: 100%;
	min-height: 120px;
	object-fit: cover;
}

.head-tabs {
	height: 42px;
	flex: 0 0 42px;
	margin: 12px 16px 0;
	padding: 5px;
	display: flex;
	align-items: center;
	border-radius: 13px;
	border: 1px solid rgba(126, 101, 75, 0.78);
	background: #242322;
	box-sizing: border-box;
}

.tab-item {
	min-width: 74px;
	height: 30px;
	line-height: 30px;
	border-radius: 10px;
	color: #aeb3bb;
	font-size: 12px;
	text-align: center;
}

.tab-item.active {
	color: #ffd0ad;
	font-weight: 700;
	background: linear-gradient(180deg, #755f48 0%, #5f4c39 100%);
}

.tab-content {
	flex: 1;
	overflow-y: auto;
	padding-bottom: 84px;
	-webkit-overflow-scrolling: touch;
}

.pblBox {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
	padding: 14px 16px 0;
}

.releaseItem {
	min-width: 0;
	padding: 0 0 12px;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(128, 101, 74, 0.88);
	background: #292929;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	box-sizing: border-box;
}

.imgBox {
	position: relative;
	overflow: hidden;
	aspect-ratio: 1 / 1.35;
	background: #1b1a1a;
}

.imgBox > img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.corner-ribbon {
	position: absolute;
	top: -50px;
	right: -50px;
	z-index: 1;
	width: 90px;
	height: 90px;
	background: #7d654f;
	color: #ffd0ad;
	transform: rotate(45deg);
}

.corner-ribbon i {
	position: absolute;
	bottom: 6px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	white-space: nowrap;
}

.infoBox {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	height: 40px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	color: #fff;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
	box-sizing: border-box;
}

.location-icon {
	color: #ffd0ad;
	font-size: 14px;
}

.wantyuebtn {
	margin-left: auto;
	padding: 5px 8px;
	border-radius: 8px;
	border: 1px solid rgba(255, 208, 173, 0.72);
	color: #ffd0ad;
	font-size: 12px;
	font-weight: 700;
}

.tagBox {
	min-height: 33px;
	padding: 9px 10px 0;
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
}

.tag {
	max-width: 100%;
	padding: 4px 8px;
	border-radius: 8px;
	background: rgba(255, 208, 173, 0.12);
	color: #ffd0ad;
	font-size: 12px;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.di {
	padding: 9px 10px 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #aeb3bb;
	font-size: 12px;
	line-height: 18px;
}

.name-row,
.like-row {
	min-width: 0;
	display: flex;
	align-items: center;
}

.name-row span:last-child {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.dot {
	width: 9px;
	height: 9px;
	flex: 0 0 9px;
	margin-right: 5px;
	border-radius: 50%;
	background: #efba8f;
}

.like-row {
	flex: 0 0 auto;
	margin-left: 8px;
	color: #ff6ca8;
}

.like-row span {
	margin-left: 3px;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description,
/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: #9aa1aa;
}

@media screen and (max-width: 374px) {
	.banner-swipe,
	.head-tabs {
		margin-right: 12px;
		margin-left: 12px;
	}

	.pblBox {
		gap: 10px;
		padding-right: 12px;
		padding-left: 12px;
	}
}
</style>
